import classNames from 'classnames';
import { FunctionComponent, useState } from 'react';
import useClipboard from 'react-use-clipboard';
import { HiddenFieldProps } from './HiddenFieldProps';

export const HiddenField: FunctionComponent<HiddenFieldProps> = ({ text }) => {
  const [isHidden, setIsHidden] = useState<boolean>(true);
  const [isCopied, setCopied] = useClipboard(text, { successDuration: 2000 });

  function toggleIsHidden(): void {
    setIsHidden(!isHidden);
  }

  function copy(): void {
    setCopied();
  }

  return (
    <div className="pr-3 h-stack items-center bg-bg-tertiary box-border rounded-lg">
      <input
        className={classNames('w-full px-3 py-1 bg-transparent rounded-lg filter', isHidden ? 'blur-sm' : 'blur-none')}
        value={text}
        readOnly
      />

      <div className="h-stack items-center space-x-2">
        <button onClick={toggleIsHidden}>
          <img className="w-6 h-6" src="/images/icons/eye.svg" />
        </button>

        {isCopied ? (
          <div className="w-6 h-6">
            <img src="/images/icons/check.svg" />
          </div>
        ) : (
          <button onClick={copy}>
            <img className="w-6 h-6 h-stack items-center justify-center" src="/images/icons/copy.svg" />
          </button>
        )}
      </div>
    </div>
  );
};
